module.exports = __webpack_public_path__ + "img/cusi-logo.33630f23.jpg";